import { render, staticRenderFns } from "./blueToothList.vue?vue&type=template&id=2536ede0&scoped=true&"
import script from "./blueToothList.vue?vue&type=script&lang=js&"
export * from "./blueToothList.vue?vue&type=script&lang=js&"
import style0 from "./blueToothList.vue?vue&type=style&index=0&id=2536ede0&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "2536ede0",
  null
  
)

export default component.exports